<template>
  <b-modal
    id="modal-route-monitoring"
    ref="modal-route-monitoring"
    size="sm"
    modal-class="
        mc-modal-info mc-modal-info--route
      "
    hide-header
    hide-footer
    scrollable
    no-close-on-backdrop
    hide-backdrop
    centered
    no-enforce-focus
  >
    <h4 class="mc-modal-info__head">
      {{ item?.name }}
      <i class="mc-fa icon-outline_close" @click="close"></i>
    </h4>
    <div class="mc-modal-info--route-wrapper">
      <div class="mc-modal-info--route-item">
        <h5 class="mc-modal-info--route-item-title">
          {{ $t('global.scheduled') }}
          <i class="mc-fa icon-outline_info" id="tooltipScheduleRoute"></i>
          <b-tooltip target="tooltipScheduleRoute" triggers="hover">
            {{ $t('route.tooltipScheduleRoute') }}
          </b-tooltip>
        </h5>
        <div class="d-flex justify-content-between mc-modal-info__list-detail-row">
          <i class="mc-fa icon-outline_arrow-right"></i>
          <dl class="mc-modal-info__list-detail">
            <dt>{{ $t('global.start') }}</dt>
            <dd>{{ momentDMY_HI(item?.expectedStartOn) }}</dd>
          </dl>
          <dl class="mc-modal-info__list-detail">
            <dt>{{ $t('global.finish') }}</dt>
            <dd>{{ momentDMY_HI(item?.expectedEndOn) }}</dd>
          </dl>
        </div>
        <div class="d-flex justify-content-between mc-modal-info--route-item-type">
          <span><i class="bg-main-route"></i> {{ $t('master.list.route.routePrimary') }}</span>
          <div class="form-check-right form-switch">
            <input
              class="form-check-input me-0"
              type="checkbox"
              v-model="radio.primary"
              @change="changeSetting"
            />
            <span v-if="item?.route_plan?.length" class=""
              >{{ item.route_plan[0].distance_label }} Km</span
            >
          </div>
        </div>
        <div
          v-if="item?.route_plan?.length === 2"
          class="d-flex justify-content-between mc-modal-info--route-item-type"
        >
          <span
            ><i class="bg-alternative-route"></i>
            {{ $t('master.list.route.routeAlternative') }}</span
          >
          <div class="form-check-right form-switch">
            <input
              class="form-check-input me-0"
              type="checkbox"
              v-model="radio.alternative"
              @change="changeSetting"
            />
            <span class="">{{ item?.route_plan[1].distance_label }} Km</span>
          </div>
        </div>
      </div>
      <div class="mc-modal-info--route-item" v-if="item?.status !== 'scheduled'">
        <h5 class="mc-modal-info--route-item-title d-flex justify-content-between">
          <div class="mt-2">
            {{ $t('global.actual') }}
            <i class="mc-fa icon-outline_info" id="tooltipActualRoute"></i>
            <b-tooltip target="tooltipActualRoute" triggers="hover">
              {{ $t('route.tooltipActualRoute') }}
            </b-tooltip>
          </div>
          <b-button
            @click="refreshData"
            variant="outline-primary"
            size="sm"
            v-if="item?.status === 'progress'"
          >
            <i class="icon-fill_refresh"></i>
          </b-button>
        </h5>
        <div class="d-flex justify-content-between mc-modal-info__list-detail-row">
          <i class="mc-fa icon-outline_arrow-right"></i>
          <dl class="mc-modal-info__list-detail">
            <dt>{{ $t('global.start') }}</dt>
            <dd>{{ item?.startOn ? momentDMY_HI(item?.startOn) : '-' }}</dd>
          </dl>
          <dl class="mc-modal-info__list-detail">
            <dt v-if="item?.status === 'done'">{{ $t('global.finish') }}</dt>
            <dt v-else>{{ $t('global.latPoint') }}</dt>
            <dd>{{ item?.endOn ? momentDMY_HI(item?.endOn) : '-' }}</dd>
          </dl>
        </div>
        <div class="d-flex justify-content-between mc-modal-info--route-item-type">
          <span><i class="bg-warning"></i> {{ $t('master.list.route.routeActual') }}</span>
          <div class="form-check-right form-switch">
            <input
              class="form-check-input me-0"
              type="checkbox"
              v-model="radio.actual"
              @change="changeSetting"
            />
            <span class="">{{ item?.distanceDriven }} Km</span>
          </div>
        </div>
      </div>
      <div class="mc-modal-info--route-item" v-if="item.status != 'scheduled'">
        <div class="d-flex justify-content-between mc-modal-info-route-item__notifText">
          <span
            ><i class="mc-fa icon-outline_bell"></i>
            {{ $t('route.routeMonitoring.notifText') }}</span
          ><span>{{ item.missedRoutes.total }}</span>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'

export default {
  name: 'ModalRouteMonitoring',
  mixins: [responsive, Helper],
  props: {
    route: {
      required: true,
    },
  },
  data() {
    return {
      showHideDetail: false,
      radio: {
        primary: true,
        alternative: true,
        actual: true,
      },
      item: null,
    }
  },
  watch: {
    route: {
      async handler(val) {
        await this.fetchRouteData(val)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    changeSetting() {
      this.$parent.$parent.$emit('onChangeSettingLine', this.radio)
    },
    refreshData() {
      this.item.endOn = this.now()
      this.$parent.$parent.$emit('onRefresh')
    },
    close() {
      this.$bvModal.hide('modal-route-monitoring')
    },
    async fetchRouteData(val) {
      this.item = val
      this.item.endOn = this.item.status === 'progress' ? this.now() : this.item.endOn
    },
  },
}
</script>
